export function normalize(value) {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

export function getStockholmDateKey() {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Stockholm',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

export function getPreviousDateKey(dateKey) {
  const date = new Date(`${dateKey}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() - 1);
  return date.toISOString().slice(0, 10);
}

export function getDailyStateKey(dateKey) {
  return `korvdle:day:${dateKey}`;
}

export function smokeLabel(level) {
  return ['ingen', 'låg', 'medel', 'hög', 'mycket hög'][level] || 'okänd';
}

export function spiceLabel(level) {
  return ['', 'mild', 'lätt kryddig', 'kryddig', 'het', 'mycket het'][level] || 'okänd';
}

export function defaultStats() {
  return {
    played: 0,
    won: 0,
    streak: 0,
    best: null,
    lastPlayedKey: null,
  };
}

export function buildShareText({ guesses, todayKey, maxGuesses, result }) {
  const rows = guesses
    .map((entry) => {
      const mapping = [
        entry.comparison.country,
        entry.comparison.meats,
        entry.comparison.smoke,
        entry.comparison.spice,
        entry.comparison.serving,
        entry.comparison.texture,
      ];

      return mapping
        .map((status) => (status === 'green' ? '🟩' : status === 'yellow' ? '🟨' : '⬛'))
        .join('');
    })
    .join('\n');

  const score = result === 'won' ? `${guesses.length}/${maxGuesses}` : `X/${maxGuesses}`;
  return `Korvdle ${todayKey} ${score}\n${rows}`;
}